import cn from 'classnames';
import Button from 'components/button-new';
import ImpressionTrackerNew from 'components/impression-tracker/new-impression-tracker';
import { PetType } from 'constants/pet-type';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CdpTileIllustration from '../assets/cdp-tile-illustration.svg';
import { AiWeightEntryPointId } from '../constants';
import { PET_CONFIG } from '../pet-config';

interface Props {
  entryPointId: AiWeightEntryPointId;
  petType: PetType;
  petName?: string;
  onCta: () => void;
  className?: string;
  dataTest?: string;
}

export const AiWeightTile: FC<Props> = ({
  entryPointId,
  petType,
  petName,
  onCta,
  className,
  dataTest,
}) => {
  const { formatMessage } = useIntl();
  const { TileBlob, tileBgClass } = PET_CONFIG[petType];
  const petLabel = formatMessage({ id: `ai-weight-analyzer:pet-label:${petType}` });

  const cdpTitleId = petName
    ? 'ai-weight-analyzer:entry:cdp-tile:title:with-name'
    : 'ai-weight-analyzer:entry:cdp-tile:title';

  return (
    <ImpressionTrackerNew element={['ai-weight-analyzer', entryPointId, petType]}>
      <div
        data-test={dataTest ?? `ai-weight-entry-${entryPointId}`}
        className={cn(
          'relative flex items-center gap-2.5 overflow-hidden rounded p-3',
          tileBgClass,
          className
        )}
      >
        <div
          aria-hidden="true"
          className="absolute -top-[117px] -left-14 flex h-[302px] w-[542px] items-center justify-center"
        >
          <div className="flex-none" style={{ transform: 'scaleY(-1) rotate(10.77deg)' }}>
            <TileBlob className="block h-[210px] w-[512px]" />
          </div>
        </div>

        <CdpTileIllustration aria-hidden="true" className="relative z-1 size-[100px] shrink-0" />

        <div className="relative z-1 flex w-[210px] flex-col items-start gap-2">
          <p
            className="text-text-dark-bg-secondary text-base leading-[1.5]"
            data-test={`ai-weight-entry-${entryPointId}-title`}
          >
            <FormattedMessage id={cdpTitleId} values={{ petName, petLabel }} />
          </p>
          <Button
            size="base"
            layout="contained"
            onClick={onCta}
            data-test={`ai-weight-entry-${entryPointId}-cta`}
          >
            <FormattedMessage id="ai-weight-analyzer:entry:cdp-tile:cta" />
          </Button>
        </div>
      </div>
    </ImpressionTrackerNew>
  );
};
